"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoBannerText = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../../../contexts");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PromoBannerText = (param)=>{
    let { title, caption, promoBannerType, link } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { isFocusPage } = (0, _contexts.useBannerProductListingContext)();
    const { title: linkTitle } = link !== null && link !== void 0 ? link : {};
    if (!title) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
        promoBannerType: promoBannerType,
        "data-testid": getTestId(_constants.BANNER_TEXT),
        isFocusPage: isFocusPage,
        children: [
            isFocusPage && caption ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.CaptionText, {
                "data-testid": getTestId(_constants.BANNER_TEXT_CAPTION),
                children: caption
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
                component: "p",
                variant: isFocusPage ? 'h5' : 'h6',
                promoBannerType: promoBannerType,
                isFocusPage: isFocusPage,
                children: title
            }),
            linkTitle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LinkImitation, {
                "data-testid": getTestId(_constants.BANNER_TEXT_LINK),
                className: isFocusPage ? undefined : _constants.BannerTextLinkClassName,
                promoBannerType: promoBannerType,
                color: isFocusPage ? 'primary' : 'default',
                variant: isFocusPage ? 'contained' : 'text',
                size: isFocusPage ? 'medium' : 'small',
                isFocusPage: isFocusPage,
                children: linkTitle
            }) : null
        ]
    });
};
exports.PromoBannerText = PromoBannerText;
